import VueI18n from "vue-i18n";
import * as hiLinkDefault from "../../static/js/default.js";
import zh from "./zh";

// 国际化
const i18n = new VueI18n({
  locale: hiLinkDefault.medical.language || getUal(),
  silentFallbackWarn: true,
  messages: {
    zh: zh, // 中文语言包
  
  }
});
function getUal() {
  var ual = navigator.language;
  return hiLinkDefault.getUal(ual);
}
export default i18n;



// WEBPACK FOOTER //
// ./src/lang/index.js